import { render } from "./BangladeshGuideline.vue?vue&type=template&id=127ccd75&scoped=true"
import script from "./BangladeshGuideline.vue?vue&type=script&lang=js"
export * from "./BangladeshGuideline.vue?vue&type=script&lang=js"

import "./BangladeshGuideline.vue?vue&type=style&index=0&id=127ccd75&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127ccd75"]])

export default __exports__